import { Box, Stack, Text } from '@mantine/core'
import ReactMarkdown from 'react-markdown'

import type { HelpEntry } from '@/configs/helpContent.types'

type HelpEntryAnswerProps = {
  entry: HelpEntry
}

export function HelpEntryAnswer({ entry }: HelpEntryAnswerProps) {
  return (
    <Stack px="xl">
      <ReactMarkdown
        components={{
          p: ({ children }) => <Text mb="xs">{children}</Text>,
          ol: ({ children }) => (
            <Box component="ol" mt={0} mb="xs">
              {children}
            </Box>
          ),
          ul: ({ children }) => (
            <Box component="ul" mt={0} mb="xs">
              {children}
            </Box>
          ),
        }}>
        {entry.answer}
      </ReactMarkdown>
    </Stack>
  )
}
